import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import accountingModule from "@kubdee/module-accounting";

export default createModuleLayout({
  moduleId: MODULES.ACCOUNTING,
  moduleConfig: accountingModule,
});
